import { create } from "zustand";

export interface ComputeState {
  isComputing: boolean;
  isComputed: boolean;
  auditPassed: boolean | null;
  computeGeneration: number;
  computeError: string | null;
}

export interface ComputeActions {
  setComputeState: (state: Partial<ComputeState>) => void;
  incrementGeneration: () => void;
}

export type ComputeStore = ComputeState & ComputeActions;

export const useComputeStore = create<ComputeStore>((set) => ({
  isComputing: false,
  isComputed: false,
  auditPassed: null,
  computeGeneration: 0,
  computeError: null,

  setComputeState: (partial) => set(partial),

  incrementGeneration: () =>
    set((state) => ({ computeGeneration: state.computeGeneration + 1 })),
}));
